module.exports = __webpack_public_path__ + "static/media/MetuoPersonalUse-Regular.c4117475.otf";